
import { Options, Vue } from "vue-class-component";
@Options({})
export default class Empty extends Vue {}
